import { useState } from 'react';
import { signOut } from 'next-auth/client';
import { useRouter } from 'next/router';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import Link from 'components/general/Link';

import Panel from '@inspire/ui/general/Panel';
import Spinner from '@inspire/ui/chakra/Spinner';

import { CONNEXION_PATH } from 'lib/paths';
import { handleErrors } from 'lib/errors';
import { useDevenirEclaireurMutation } from 'lib/generated';
import {
  useMyProfile,
  useQuestionnairePath,
  useSetLyceeStudyYear,
} from 'lib/hooks';

import MemeSrc from '../../../public/img/meme-passage-EE.png';
import ClickableImage from 'components/general/ClickableImage';

const DevenirEclaireurContent = () => {
  const { push } = useRouter();
  const { mutateAsync: devenirEclaireurAsync } = useDevenirEclaireurMutation();
  const [isBecomingEclaireur, setIsBecomingEclaireur] = useState(false);
  const questionnairePath = useQuestionnairePath();
  const { myProfile, refetchMyProfile } = useMyProfile();

  const { setLyceeStudyYearAsync } = useSetLyceeStudyYear({
    onSuccess: async () => await refetchMyProfile(),
  });

  return (
    <Box textAlign="center">
      {isBecomingEclaireur ? (
        <>
          <Spinner size="xl" thickness="4px" />
          <Text>Nous transformons ton compte en compte Éclaireur...</Text>
          <Text>
            Tu vas être déconnecté. Connecte-toi de nouveau pour compléter ton
            profil Éclaireur.
          </Text>
        </>
      ) : (
        <Box as={Panel}>
          <Heading>Alors ? Fini le lycée ?</Heading>
          <ClickableImage
            src={MemeSrc}
            alt="Meme passage éclaireur"
            href="/img/meme-passage-EE.png"
          />
          <Text>
            Si nos calculs sont bons, tu n’es plus en Terminale. Tu ne peux donc
            plus contacter d’Éclaireurs.
          </Text>
          <Text>
            Si ces informations sont incorrectes, tu peux refaire{' '}
            <Link
              href={questionnairePath}
              onClick={() => {
                // user already set to 'Post-bac' here
                // get the lyceeStudies item corresponding to the year before 'Post-bac'
                const lyceeStudies = myProfile?.lyceeStudies.sort(
                  (a, b) => b.annee - a.annee
                )[1];

                // reset the lyceeStudies to the one before 'Post-bac'
                setLyceeStudyYearAsync(lyceeStudies);
              }}
            >
              le questionnaire
            </Link>
            .
          </Text>
          <Text>
            Transforme ton compte en compte Éclaireur pour à ton tour conseiller
            des lycéens sur ta filière d’étude.
          </Text>
          <Text color={'red'}>
            Attention ! Dans ce cas, tu ne pourras plus revenir en arrière !
          </Text>
          <Button
            onClick={async () => {
              try {
                setIsBecomingEclaireur(true);
                await devenirEclaireurAsync(null);
                setTimeout(() => {
                  signOut();
                  push(CONNEXION_PATH);
                }, 6000);
              } catch ({ err }) {
                handleErrors(err);
              }
            }}
          >
            Devenir Éclaireur
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default DevenirEclaireurContent;
